'use strict';
import React from 'react';
import {times} from 'lodash';

export default class CheckoutCartItem extends React.Component {
    deleteItem(e) {
        e.preventDefault();
        this.props.actions.removeItem({
            product_id: this.props.product.get('id')
        });
    }
    onChange(event) {
        this.props.actions.changeItem({
            product_id: this.props.product.get('id'),
            quantity: event.target.value
        });
    }
    renderQty(product) {
        if (this.props.readOnly) {
            return product.quantity;
        } else {
            return (
                <select onChange={::this.onChange} defaultValue={product.quantity}>
                    {times(10, (i) => {
                        return <option value={i + 1}>{i + 1}</option>;
                    })}
                </select>
            );
        }
    }
    renderActions() {
        if (!this.props.readOnly) {
            return (
                <td className="item__action">
                    <a href="#" onClick={::this.deleteItem}><i className="icon icon-remove" /></a>
                </td>
            );
        }
    }
    render() {
        let {product} = this.props;
        product = product.toJS();
        return (
            <tr className="cart__item">
                <td className="item__image">
                {product.image && <img src={product.image} />}
                </td>
                <td className="item__name">
                    {product.name}<br />
                    <div className="name__dimensions">
                        <i className="icon icon-dimensions" />{product.dimensions}
                    </div>
                    <div className="name__delivery">
                        {product.delivery}
                    </div>

                    <div className="item__description--mobile">
                        <div className="description__qyt">
                            {this.renderQty(product)}
                        </div>
                        <div className="description__plus">
                            X
                        </div>
                        <div className="description__price">
                            {product.price}
                        </div>
                        <div className="description__equals">
                            =
                        </div>
                        <div className="description__subtotal">
                            {product.subtotal}
                        </div>
                    </div>
                </td>
                <td className="item__qyt">
                    {this.renderQty(product)}
                </td>
                <td className="item__price">
                    {product.price}
                </td>
                <td className="item__sum">
                    {product.subtotal}
                </td>
                {this.renderActions()}
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/cart/checkoutCartItem.jsx